/** Derive up to two uppercase initials from a contact name.
 *  Falls back to the first character for non-alphabetic names (e.g. raw phone numbers). */
export function getInitials(name: string | null | undefined): string {
  if (!name) return '?';
  const words = name.trim().split(/\s+/).filter((w) => /^[a-zA-Z]/.test(w));
  if (words.length === 0) return name.trim().charAt(0) || '?';
  return words
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase())
    .join('');
}
